
export default {
  install(Vue) {
    Vue.prototype.$loading = {
      el: null,

      start() {
        this.stop(true);
        let el = document.createElement('div');
        el.className = 'page-loading'
        let bar = document.createElement('div');
        bar.className = 'bar';
        bar.style.transitionDuration = '1500ms';
        el.appendChild(bar);
        document.body.appendChild(el);
        // 强制渲染，以进行动画
        bar.offsetLeft;
        bar.style.width = '90%';
        this.el = el;
      },

      stop(force = false) {
        if (this.el) {
          let el = this.el, bar = this.el.children[0];
          bar.style.transitionDuration = '200ms';
          bar.style.width = '100%';
          this.el = null;
          if (force) {
            document.body.removeChild(el);
          } else {
            setTimeout(() => {
              document.body.removeChild(el);
            }, 200);
          }
        }
      }
    }
  }
}